<template>
  <div id="payroll">
    <div class="select-month">
      <span class='title'>Month</span>
      <el-date-picker v-model="month"
                      type="month"
                      placeholder="select month"
                      value-format="yyyy-MM">
      </el-date-picker>
      <button class="search-btn"
              @click="getPayroll()">Search</button>
    </div>
    <ul class="table"
        v-for="item in payrollList"
        :key="item.teaNo">
      <li>
        <div>Name</div>
        <div>{{item.teacherName}}</div>
      </li>
      <li>
        <div>ID</div>
        <div>{{item.teaNo}}</div>
      </li>
      <li>
        <div>Bank Charges</div>
        <div>{{item.bankCharge}}</div>
      </li>
      <li>
        <div>Rate</div>
        <div>{{item.rate}}</div>
      </li>
      <li>
        <div>Opened Class</div>
        <div>{{item.openedClass}}</div>
      </li>
      <li>
        <div>Finished Class</div>
        <div>{{item.finishedClass}}</div>
      </li>
      <li>
        <div>1V1 Class</div>
        <div>{{item.a1v1Class}}</div>
      </li>
      <li>
        <div>Stu absent</div>
        <div>{{item.stuAbsent}}</div>
      </li>
      <li>
        <div>Sub total</div>
        <div>{{item.subTotal}}</div>
      </li>
      <li>
        <div>OC total</div>
        <div>{{item.ocTotal}}</div>
      </li>
      <li>
        <div>A with n</div>
        <div>{{item.awithN}}</div>
      </li>
      <li>
        <div>A without n</div>
        <div>{{item.awithoutN}}</div>
      </li>
      <li>
        <div>Deduction</div>
        <div>{{item.leaveDeduct}}</div>
      </li>
      <li>
        <div>A with n(2h&lt;&#61;T&lt;5day)</div>
        <div>{{item.cancelType1}}</div>
      </li>
      <li>
        <div>A with n(T&lt;2h)</div>
        <div>{{item.cancelType2}}</div>
      </li>
      <li>
        <div>Complaint(General)</div>
        <div>{{item.complainGeneral}}</div>
      </li>
      <li>
        <div>Complaint(Serious)</div>
        <div>{{item.complainSerious}}</div>
      </li>
      <li>
        <div>NO comment</div>
        <div>{{item.noComment}}</div>
      </li>
      <li>
        <div>NO comment(Stu absent)</div>
        <div>{{item.noCommentStuAbsent}}</div>
      </li>
      <li>
        <div>Total deduct</div>
        <div>{{item.totalDeduct}}</div>
      </li>
      <li>
        <div>Attendance award</div>
        <div>{{item.attendanceAward}}</div>
      </li>
      <li>
        <div>Book award</div>
        <div>{{item.bookAward}}</div>
      </li>
      <li>
        <div>GC S(mins)</div>
        <div>{{item.gcS}}</div>
      </li>
      <li>
        <div>GC B min</div>
        <div>{{item.gcB}}</div>
      </li>
      <li>
        <div>GC total</div>
        <div>{{item.gcTotal}}</div>
      </li>
      <li>
        <div>Bonus</div>
        <div>{{item.bonus}}</div>
      </li>
      <li>
        <div>Salary coefficient</div>
        <div>{{item.salaryCoefficient}}</div>
      </li>
      <li>
        <div>Total</div>
        <div>{{item.total}}</div>
      </li>
    </ul>
    <ul class="member-table"
        v-for="item in memberList"
        :key="item.teaNo">
      <li>
        <div>NAME</div>
        <div>{{item.teacherName}}</div>
      </li>
      <li>
        <div>ID</div>
        <div>{{item.teaNo}}</div>
      </li>
      <li>
        <div>Bank charge</div>
        <div>{{item.bankCharge}}</div>
      </li>
      <li>
        <div>Total</div>
        <div>{{item.total}}</div>
      </li>
    </ul>
  </div>
</template>
<script>
import './index.less';
import timeTools from '@/utils/timeTools';
export default {
  created() {
    this.getPayroll();
  },
  data() {
    return {
      month: timeTools.getPreMonth(new Date()).slice(0, 7), //默认上一个月份
      payrollList: [],
      memberList: [],
      isData: false,
    };
  },
  methods: {
    async getPayroll() {
      try {
        const res = await this.$api.getNotBasePayroll(this.month);
        this.payrollList = res.data.resultData.teacherSalaryRespDTO || [];
        this.memberList = res.data.resultData.teacherMemberShipSalaryRespDTO || [];
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/Payroll/index.vue